import { Rating } from 'domain/types';

const MAX_RATING_VALUE = 4;

export function invertRatingValue(rating: Rating): Rating;
export function invertRatingValue(rating: number): number;
export function invertRatingValue(rating: number): number {
  return MAX_RATING_VALUE - rating;
}
